import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { GraphqlService } from '../graphql/graphql.service';

export const adminGuard = () => {
  const msalService = inject(MsalService);
  const graphqlService = inject(GraphqlService);
  const router = inject(Router);

  const account =
    msalService.instance.getActiveAccount() ??
    msalService.instance.getAllAccounts()[0];

  if (!account) {
    return router.createUrlTree(['/auth/login']);
  }

  return graphqlService.verifyUser(account.username).pipe(
    map(user => {
      if (!user || user.role?.toLowerCase() !== 'admin') {
        return router.createUrlTree(['/auth/login'], { queryParams: { error: 'unauthorized' } });
      }
      return true;
    }),
    catchError(() => of(router.createUrlTree(['/auth/login'], { queryParams: { error: 'auth_failed' } }))),
  );
};
